import { InstrumentLight, InstrumentType } from "../../../Config/types"

export enum Broker {
  EXEC_DESK = "EXEC DESK",
  GS = "GS",
  JPM = "JPM",
  TOUR = "TOUR",
  BOFA = "BOFA",
  EXEC_DESK_PM = "EXEC DESK - PM",
}

/**
 * Get the available brokers from the instrument
 * @param instrument
 * @param directOrdersEnabled
 * @param account
 * @returns the available brokers from the instrument and account
 */
export const getBrokersFromInstrumentAccount = (
  instrument: InstrumentLight | null,
  directOrdersEnabled: boolean,
  account: string,
): Record<string, string> => {
  if (directOrdersEnabled && instrument?.type === InstrumentType.INDEX) {
    return {
      [Broker.JPM]: Broker.JPM,
      [Broker.EXEC_DESK_PM]: Broker.EXEC_DESK_PM,
    }
  }

  // Check if the exchange's country code is US or PL (Poland)
  if (
    directOrdersEnabled &&
    (instrument?.exchange_country_code === "US" || instrument?.exchange_country_code === "PL")
  ) {
    if (account.includes("SP")) {
      return {
        [Broker.BOFA]: Broker.BOFA,
        [Broker.TOUR]: Broker.TOUR,
        [Broker.EXEC_DESK_PM]: Broker.EXEC_DESK_PM,
      }
    } else if (account.includes("QRT")) {
      return {
        [Broker.GS]: Broker.GS,
        [Broker.EXEC_DESK_PM]: Broker.EXEC_DESK_PM,
      }
    }
  }

  // For other countries, return all brokers
  // In direct orders mode, exclude EXEC_DESK (use EXEC_DESK_PM instead)
  return Object.values(Broker).reduce(
    (acc, broker) => {
      // Skip EXEC_DESK in direct orders mode
      if (directOrdersEnabled && broker === Broker.EXEC_DESK) {
        return acc
      }
      acc[broker] = broker
      return acc
    },
    {} as Record<string, string>,
  )
}
